// extracted by mini-css-extract-plugin
export var button = "_lz-2";
export var card = "_lz-0";
export var closeButtonContainer = "_lz-3";
export var iconContainer = "_lz-1";